var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1217_3736)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0C5.59648 0 0 5.59648 0 12.5C0 19.4039 5.59648 25 12.5 25C19.4039 25 25 19.4039 25 12.5C25 5.59648 19.4039 0 12.5 0ZM12.5 23.4621C6.46914 23.4621 1.5625 18.5309 1.5625 12.5C1.5625 6.46909 6.46914 1.56245 12.5 1.56245C18.5309 1.56245 23.4375 6.46912 23.4375 12.5C23.4375 18.5308 18.5309 23.4621 12.5 23.4621ZM16.9191 8.08086C16.6141 7.77578 16.1195 7.77578 15.8145 8.08086L12.5 11.3953L9.18555 8.08086C8.88047 7.77578 8.38594 7.77578 8.08047 8.08086C7.77539 8.38594 7.77539 8.88047 8.08047 9.18555L11.3949 12.5L8.08047 15.8145C7.77539 16.1191 7.77539 16.6145 8.08047 16.9192C8.38555 17.2242 8.88008 17.2242 9.18555 16.9192L12.5 13.6047L15.8145 16.9192C16.1195 17.2242 16.6141 17.2242 16.9191 16.9192C17.2242 16.6145 17.2242 16.1191 16.9191 15.8145L13.6047 12.5L16.9191 9.18555C17.2246 8.88008 17.2246 8.38555 16.9191 8.08086Z",
    fill: "#003C9D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1217_3736"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.e8a86fb4e574266c9990221787db654e.svg";
export { ForwardRef as ReactComponent };